module.exports = __webpack_public_path__ + "img/10_icon.a7550e41.svg";